import { render, staticRenderFns } from "./product_group.vue?vue&type=template&id=f18cd69a"
import script from "./product_group.vue?vue&type=script&lang=js"
export * from "./product_group.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports